import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToHash from "@/components/ScrollToHash";
import HomePage from "@/pages/HomePage";
import OnboardingPage from "@/pages/OnboardingPage";
import UploadPage from "@/pages/UploadPage";
import DashboardPageV2 from "@/pages/DashboardPageV2";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import DiagnosticPage from "@/pages/DiagnosticPage";
import MentionsLegales from "@/pages/legal/MentionsLegales";
import Confidentialite from "@/pages/legal/Confidentialite";
import CGU from "@/pages/legal/CGU";
import Contact from "@/pages/legal/Contact";
import UnderstandNotarialDocument from "@/pages/library/UnderstandNotarialDocument";
import DeclarationSuccession from "@/pages/library/DeclarationSuccession";
import ActeNotoriete from "@/pages/library/ActeNotoriete";
import DonationPartage from "@/pages/library/DonationPartage";
import Testament from "@/pages/library/Testament";
import AttestationImmobiliere from "@/pages/library/AttestationImmobiliere";
import ActeDeVente from "@/pages/library/ActeDeVente";
import Sci from "@/pages/library/Sci";
import Indivision from "@/pages/library/Indivision";
import CourrierNotarial from "@/pages/library/CourrierNotarial";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/start" element={<OnboardingPage />} />
            <Route path="/upload" element={<UploadPage />} />
            <Route path="/dashboard" element={<DashboardPageV2 />} />
            <Route path="/paiement-succes" element={<PaymentSuccessPage />} />
            <Route path="/diagnostic" element={<DiagnosticPage />} />
            <Route path="/comprendre-document-notarie" element={<UnderstandNotarialDocument />} />
            <Route path="/declaration-succession" element={<DeclarationSuccession />} />
            <Route path="/acte-notoriete" element={<ActeNotoriete />} />
            <Route path="/donation-partage" element={<DonationPartage />} />
            <Route path="/testament" element={<Testament />} />
            <Route path="/attestation-immobiliere" element={<AttestationImmobiliere />} />
            <Route path="/acte-de-vente" element={<ActeDeVente />} />
            <Route path="/sci" element={<Sci />} />
            <Route path="/indivision" element={<Indivision />} />
            <Route path="/courrier-notarial" element={<CourrierNotarial />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/cgu" element={<CGU />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
